"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get TeamsIntegrationConfigModel () {
        return TeamsIntegrationConfigModel;
    },
    get TeamsIntegrationWorkerModel () {
        return TeamsIntegrationWorkerModel;
    },
    get TeamsNotificationsModel () {
        return TeamsNotificationsModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const TeamsIntegrationConfigModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    deleted: _zod.z.boolean(),
    deleted_at: _zod.z.date(),
    settings: _zod.z.object({}),
    tenant_id: _zod.z.string(),
    updated_at: _zod.z.date()
});
const TeamsNotificationsModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]),
    created_at: _zod.z.date(),
    employee_id: _zod.z.instanceof(_bson.ObjectId),
    notification_documents: _zod.z.string(),
    notification_settings_url: _zod.z.string(),
    notification_type: _zod.z.enum([
        "asap",
        "deferred"
    ]),
    sent_at: _zod.z.union([
        _zod.z.date(),
        _zod.z.null()
    ]),
    stage: _zod.z.string(),
    status: _zod.z.string(),
    transaction_id: _zod.z.union([
        _zod.z.string(),
        _zod.z.null()
    ]),
    updated_at: _zod.z.date()
});
const TeamsIntegrationWorkerModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    app_install_status: _zod.z.object({
        status: _zod.z.enum([
            "installed",
            "uninstalled"
        ])
    }),
    company_id: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]),
    created_at: _zod.z.date(),
    date: _zod.z.date().optional(),
    microsoft_tenant_id: _zod.z.string(),
    microsoft_user_data: _zod.z.object({
        "@odata.context": _zod.z.string(),
        businessPhones: _zod.z.array(_zod.z.string()),
        displayName: _zod.z.string(),
        givenName: _zod.z.string(),
        id: _zod.z.string(),
        jobTitle: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ]),
        mail: _zod.z.string(),
        mobilePhone: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ]),
        officeLocation: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ]),
        preferredLanguage: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ]),
        surname: _zod.z.union([
            _zod.z.string(),
            _zod.z.null()
        ])
    }),
    microsoft_user_id: _zod.z.string(),
    microsoft_user_name: _zod.z.string(),
    performyard_user_id: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]),
    stored_conversation_reference: _zod.z.object({
        activityId: _zod.z.string(),
        bot: _zod.z.object({
            id: _zod.z.string(),
            name: _zod.z.string()
        }),
        channelId: _zod.z.string(),
        conversation: _zod.z.object({
            conversationType: _zod.z.string(),
            id: _zod.z.string()
        }),
        serviceUrl: _zod.z.string(),
        user: _zod.z.object({
            id: _zod.z.string(),
            name: _zod.z.string()
        })
    }),
    updated_at: _zod.z.date()
});
